import { render, staticRenderFns } from "./ELimage.vue?vue&type=template&id=1618ce10&"
import script from "./ELimage.vue?vue&type=script&lang=js&"
export * from "./ELimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports